import React, {useEffect, useState} from "react";
import {getPerformanceStats} from "../../services/CourseRepository";
import {ScrollActivatedBargraph} from "../graph/ScrollActivatedBargraph";
import {useOutletContext} from "react-router-dom";
import {MdCurrencyExchange} from "react-icons/md";
import {GiProgression} from "react-icons/gi";
import {FeedbackItem} from "../FeedbackItem";
import {FiCheckCircle, FiCircle} from "react-icons/fi";
import {ProgressBar} from "../ProgressBar";
import {RiLoopLeftFill, RiRobot3Line} from "react-icons/ri";
import {evaluateUser} from "../../services/AIRepository";
import {useError} from "../../hooks/useError";
import classNames from "classnames";
import {TagStatGraph} from "../graph/TagStatGraph";

export function StatsPanel() {

    const [tagStats, setTagStats] = useState({groups: [], keys: [], stacked: false, horizontal: true});
    const [worstTags, setWorstTags] = useState({groups: [], keys: [], stacked: false, horizontal: true});
    const [feedbacks, setFeedbacks] = useState([])
    const [coins, setCoins] = useState(0)
    const [evalCriteria, setEvalCriteria] = useState([]);
    const [toggleGraph, setToggleGraph] = useState(true);
    const [evalLoading, setEvalLoading] = useState(false);
    const [newEvalReady, setNewEvalReady] = useState(false);
    const {setErrorMessage} = useError();
    const {courseId} = useOutletContext();


    useEffect(() => {
        if (courseId != null) {
            getPerformanceStats().then(result => {
                setTagStats(result.top5.groups.length > 0 ? result.top5 : tagStats)
                setWorstTags(result.bottom5.groups.length > 0 ? result.bottom5 : worstTags)
                setFeedbacks(result.feedbacks.length == 0 ? [{feedback:"Tilbakemelding...", type:"STRENGTH", isNew: false, date: "2025-08-17"}, {feedback:"Tilbakemelding...", type:"IMPROVEMENT", isNew: false, date: "2025-08-17"}] : result.feedbacks)
                setCoins(result.coins);
                setEvalCriteria(result.evalCriteria);
                setNewEvalReady(evalCriteria.reduce((sum, item) => sum && item.completed, true))
            }).catch(err => console.log(err));
        }
    }, []);


    const evalBtnClass = classNames("btn btn-primary text-white rounded-5 py-2",{
        "disabled" : !newEvalReady,
        "disabled loading": evalLoading
    })

    return (
        <div className={""}>
            <div className={"row mb-3 "}>
                <div className={"col d-flex  align-items-center"}>
                    <div className={"btn-group"}>
                        <input type="radio" id="styrker"
                               name="toggle" className="btn-check " checked={toggleGraph}
                               onClick={() => setToggleGraph(true)}/>
                        <label htmlFor="styrker"
                               className={"btn btn-outline-success border-light border-4"}>Styrker</label>
                        <input type="radio" id="fokus" name="toggle" className={"btn-check"} checked={!toggleGraph}
                               onChange={() => setToggleGraph(false)}/>
                        <label className="btn btn-outline-danger border-light border-4 " htmlFor="fokus">Fokus</label>
                    </div>

                </div>
                <div className={"col-1 d-flex justify-content-end align-items-center "}>
                    <div className={"d-flex p-3 px-5 border-2 border rounded-5"}>
                        <RiRobot3Line size={24} className={"me-2"}/>
                        <h5 className={"m-0 p-0 fw-bold"}>{coins}</h5>
                    </div>
                </div>
            </div>
            <div className={"row mb-5"}>
                <div className={"col"}>
                    <div className={""}>

                        {
                            feedbacks.filter(item => (item.type === "STRENGTH") === toggleGraph).map(item => (
                                <div className={"mb-3 border shadow rounded p-3"}>
                                    <FeedbackItem text={item.feedback} type={item.type} date={item.date} isNew={item.isNew}/>
                                </div>
                            ))
                        }

                    </div>

                </div>
                <div className={"col-4 bg-white rounded border p-3 "}>
                    <h4 className={" fw-bold"}>Sjekkliste for ny evaluering</h4>
                    <p className={"text-muted mb-3"}>
                        Ved å gjennomføre quizzer og oppgaver i kurset, vil du etterhvert
                        få en ny evaluering med tilbakemeldinger på hva du kan forbedre.
                    </p>
                    <div className={"mb-4"}>
                        <ProgressBar
                            progress={evalCriteria.reduce((sum, item) => sum + (item.currentValue / item.requiredValue), 0) / evalCriteria.length * 100}
                            className={"bg-primary"}
                            height={23}
                            show={true}/>
                    </div>
                    {
                        evalCriteria.map(criteria => (
                            <div className={"px-4 rounded-4 border mb-2 py-2"}>
                                <div className={"row  "}>
                                    <div
                                        className={"col-1 text-center me-2 " + (criteria.completed ? "text-success" : "")}>
                                        {
                                            criteria.completed ?
                                                <FiCheckCircle size={24}/>
                                                :
                                                <FiCircle size={24}/>
                                        }

                                    </div>
                                    <div className={"col"}>
                                        <h5 className={"m-0 p-0 " + (criteria.completed ? "text-decoration-line-through text-muted " : "")}>{criteria.name}</h5>
                                    </div>

                                    <div className={"col-3 text-end"}>
                                        <p className={"text-muted m-0 p-0"}>{criteria.currentValue} / {criteria.requiredValue}</p>
                                    </div>

                                </div>
                            </div>
                        ))
                    }
                    <div className={"w-100 d-flex justify-content-center px-2"}>
                        <button
                            className={evalBtnClass+" w-100 mt-3"}
                            onClick={() => {
                                setEvalLoading(true);
                                evaluateUser(setErrorMessage)
                            }}>
                            <RiLoopLeftFill size={24} className={"me-2"}/>
                            <label>Ny evaluering</label>
                        </button>
                    </div>
                </div>
            </div>

            <div className={"row"}>
                <div className={"col  "}>
                    <div className={"row"}>
                        <div className={"col"}>
                            <h2 className={"m-0 p-0 mb-2 fw-bold"}>{toggleGraph ? "Topp 5 styrker" : "Topp 5 fokus"}</h2>
                            <p className={"text-muted"}>
                                {toggleGraph ?
                                    "Dette er temaene hvor du gjør det best i, når det gjelder quiz og oppgaver!"
                                    :
                                    "Dette er temaene du burde fokusere mest på, basert på hvordan du har svart på quiz og oppgaver."}
                            </p>

                        </div>
                    </div>

                    <div className={""}>
                        <TagStatGraph data={tagStats} keys={["apples"]} height={"50vh"} index={"person"} isStrengths={toggleGraph}/>
                    </div>
                </div>

            </div>

        </div>
    );

}